import { useCallback, useEffect } from 'react';
import api from '../services/api';

/**
 * 用戶行為追蹤 Hook
 * 用於記錄用戶的搜尋、瀏覽、加購物車等行為
 */
const useBehaviorTracking = () => {
  // 確保有 session ID
  useEffect(() => {
    let sessionId = localStorage.getItem('cart_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('cart_session_id', sessionId);
    }
  }, []);

  // 通用追蹤函數
  const track = useCallback(async (behaviorType, data = {}) => {
    try {
      await api.post('/analytics/track', {
        behavior_type: behaviorType,
        ...data
      });
    } catch (error) {
      // 追蹤失敗不影響用戶體驗，只記錄錯誤
      console.debug('行為追蹤失敗:', error);
    }
  }, []);

  // 追蹤商品瀏覽
  const trackView = useCallback((productId) => {
    track('view', { product_id: productId });
  }, [track]);

  // 追蹤搜尋
  const trackSearch = useCallback((keyword, resultCount = 0) => {
    track('search', {
      search_keyword: keyword,
      search_results: resultCount
    });
  }, [track]);

  // 追蹤加入購物車
  const trackCartAdd = useCallback((productId) => {
    track('cart_add', { product_id: productId });
  }, [track]);

  // 追蹤移除購物車
  const trackCartRemove = useCallback((productId) => {
    track('cart_remove', { product_id: productId });
  }, [track]);

  // 追蹤購買
  const trackPurchase = useCallback((productIds) => {
    productIds.forEach(productId => {
      track('purchase', { product_id: productId });
    });
  }, [track]);

  // 追蹤分類瀏覽
  const trackCategory = useCallback((categoryId) => {
    track('category_view', { category_id: categoryId });
  }, [track]);

  // 追蹤頁面瀏覽 (使用 view 類型，不傳 product_id)
  const trackPageView = useCallback((referrer) => {
    // 只記錄來源資訊到再行銷列表，不記錄 behavior (避免 visit 不在 enum 中)
    // track('view', { referrer }); // 暫時停用
  }, []);

  return {
    track,
    trackView,
    trackSearch,
    trackCartAdd,
    trackCartRemove,
    trackPurchase,
    trackCategory,
    trackPageView
  };
};

export default useBehaviorTracking;
